import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { NAV_GROUPS } from "@/lib/navigation";
import { CaretDoubleLeft, Lightning } from "@phosphor-icons/react";

export function Sidebar({ collapsed, setCollapsed }) {
  const [pinned, setPinned] = useState(() => JSON.parse(localStorage.getItem("ae_pinned") || "[]"));

  return (
    <aside
      data-testid="sidebar"
      className={`sticky top-0 hidden h-screen shrink-0 flex-col border-r border-border bg-surface transition-[width] duration-300 lg:flex ${collapsed ? "w-[76px]" : "w-[260px]"}`}
    >
      <div className="flex items-center gap-2 px-5 py-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-brand-violet to-brand-pink">
          <Lightning size={20} weight="fill" className="text-white" />
        </div>
        {!collapsed && (
          <div className="leading-tight">
            <p className="font-display text-sm font-black">Asymmetry</p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Marketing OS</p>
          </div>
        )}
      </div>

      <nav className="flex-1 overflow-y-auto px-3 pb-6">
        {NAV_GROUPS.map((group) => (
          <div key={group.label} className="mb-4">
            {!collapsed && (
              <p className="px-3 pb-1 pt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground/70">
                {group.label}
              </p>
            )}
            {group.items.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.key}
                  to={item.path}
                  end={item.path === "/"}
                  data-testid={`nav-${item.key}`}
                  className={({ isActive }) =>
                    `group flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium transition-colors duration-150 ${
                      isActive
                        ? "bg-primary/12 text-primary"
                        : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                    }`
                  }
                  title={collapsed ? item.label : undefined}
                >
                  <Icon size={20} weight="duotone" className="shrink-0" />
                  {!collapsed && <span className="truncate">{item.label}</span>}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>

      <button
        data-testid="sidebar-collapse"
        onClick={() => setCollapsed((v) => !v)}
        className="m-3 flex items-center justify-center gap-2 rounded-xl border border-border py-2 text-xs font-semibold text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
      >
        <CaretDoubleLeft size={16} className={`transition-transform ${collapsed ? "rotate-180" : ""}`} />
        {!collapsed && "Collapse"}
      </button>
    </aside>
  );
}
